export default __webpack_public_path__ + "static/media/WhitePattermLarge.fd2203b0.svg";